import { NAMESPACES } from '../utils/constants'

export const PENDING_INTAKE_POPUP_MESSAGE = (
  <>
    <p>
      You have successfully completed the review for this case. The case cannot
      proceed until the other party submits their form and hence the Intake will
      be moved to <strong>Pending Intake</strong> status.
    </p>
  </>
)

export const QUICK_DENIAL_POPUP_MESSAGE = (
  <p>{NAMESPACES.QUICK_DENIED_POPUP_MESSAGE}</p>
)

export const ADULT_PATIENT_POPUP_MESSAGE = (
  <>
    <p>Please confirm the following before proceeding:</p>

    <ul className="list-disc pl-5 mt-2 text-left">
      <li>
        <strong>ICD-10 Diagnosis Code</strong> is added
      </li>
    </ul>
  </>
)

export const MINOR_PATIENT_POPUP_MESSAGE = (
  <>
    <p>This patient is under 18. Please confirm following before proceeding:</p>

    <ul className="list-disc pl-5 mt-2 text-left">
      <li>
        <strong>Caregiver</strong> is added in Patient’s{' '}
        <strong>Associated Contacts</strong> and the{' '}
        <strong>same caregiver</strong> is included in{' '}
        <strong>Case Contacts</strong>
      </li>
      <li>
        <strong>ICD-10 Diagnosis Code</strong> is added
      </li>
    </ul>
  </>
)

export const UNRESOLVED_FACILITY_POPUP_MESSAGE = (
  <>
    Please ensure to add an <strong>Office Contact</strong> as a Healthcare{' '}
    Personnel to the Facility’s Associated Contacts and add the same contact in{' '}
    <strong>Case Contacts section</strong>
  </>
)
